import React from 'react';
import * as _ from 'lodash';

const linkRE = /(https{1}:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https{1}:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,})/gi;
const Link = ({ children, url, style }) => {
  return (<span onClick={() => { onURLPress(url) }} style={style}>{children}</span>);
};

class TextWithLinks extends React.PureComponent {

  spreadText = (text, linkStyle) => {
    let newText = text.split(linkRE);
    return _.flattenDeep(newText.map((text, i) => {
      if (text.search(linkRE) === -1) {
        return <span key={i}>{text}</span>
      } else {
        if (text.substr(-1) === '.') {
          return [
            <Link url={text}
                  key={i}
                  style={linkStyle}>
              {text.substr(0, text.length - 1)}
            </Link>,
            <span key={`dot${i}`}>.</span>
          ];
        }
        return (
          <Link url={text}
                key={i}
                style={linkStyle}>
            {text}
          </Link>
        )
      }
    }))
  };

  render() {
    const { linkStyle, text } = this.props;
    return (<div>{this.spreadText(text, linkStyle)}</div>)
  }
}

export default TextWithLinks;

const onURLPress = (link) => {
  let url = link.match(linkRE)[0];
  if (url.substr(-1) === '.' || url.substr(-1) === ',') {
    url = url.substr(0, url.length - 1);
  }
  if (url.substr(0, 1) !== 'h' && url.substr(0, 1) !== 'H') {
    url = url.substr(1);
  }
  window.open(url, '_blank');
};